import {appSchema} from '@nozbe/watermelondb';

import {userSchema} from './userSchema';

const schemas = appSchema({
  version: 27,
  tables: [userSchema],
});

export {schemas};
